module.exports = __webpack_public_path__ + "img/profile.ef3a1ee4.jpg";